import { z } from 'zod';
/** Credenciales de la API de integración (HTTP Basic) de una compañía. */
export const apiAccessInput = z.object({
    username: z
        .string()
        .trim()
        .min(3, 'Mínimo 3 caracteres')
        .max(100)
        .regex(/^[^\s:]+$/, 'Sin espacios ni dos puntos'),
    password: z.string().min(8, 'Mínimo 8 caracteres').max(100),
});
export const apiAccessSettingsInput = z.object({
    clientConsecutive: z.boolean(),
});
//# sourceMappingURL=api-access.js.map